import Vue from 'vue'
import App from './App.vue'
// import store from './store'
import router from './router'
import axios from 'axios'
import dayjs from 'dayjs'
import { isInJm } from './utils/jm_util'
import './public-path.js'
import '@/utils/http'
import i18n from './locale/i18n'
import LangInterceptor from './locale/langInterceptor'
import './assets/css/reset.css'
import './assets/css/global.css'
// import '@jdpop/element-ui/lib/theme-chalk/index.css'
import { initPcTokenSdk } from '@jd/axios-plugin-dsm/dist/securitySignHelper'

initPcTokenSdk()

if (window.ShopPageframe) {
  Vue.use(window.ShopPageframe)
}

Vue.use(LangInterceptor)
Vue.prototype.$axios = axios
Vue.prototype.$moment = dayjs

if (isInJm()) {
  require.ensure([], function (require) {
    require('./assets/css/jm-mobile.scss')
  })
}
Vue.config.productionTip = false
new Vue({
  i18n,
  // store,
  router,
  render: h => h(App),
}).$mount('#app')
